<template>
	<div>
		<navTitle><div class="pageTitle">琵琶</div></navTitle>
		<mescroll-vue ref="mescroll" :up="mescrollUp">
			<div class="list">
				<div class="titleImg"><img src="../../static/images/musicHall/titleImg.png" alt="" /></div>
				<div class="videoList flex flex-align-center flex-jus-between flex-wrap">
					<div class="videoItem" v-for="item in 10" :key="item">
						<videoItem :width="166" :height="111" :videoSrc="`https://edge.ivideo.sina.com.cn/37231934001.mp4?KID=sina,viask&Expires=1611763200&ssig=v7r1MxHtQ2&reqid=`"></videoItem>
					</div>
				</div>
			</div>
		</mescroll-vue>
	</div>
</template>

<script>
// 引入mescroll的vue组件
import MescrollVue from 'mescroll.js/mescroll.vue';
import videoItem from '@/views/components/videoItem.vue';
/* eslint-disable */
export default {
	components: {
		MescrollVue, // 注册mescroll组件
		videoItem
	},
	data() {
		return {
			title: '',
			mescrollUp: {
				callback: this.upCallback
			}
		};
	},
	created() {
		if (this.$route.query.name) this.title = this.$route.query.name;
		else {
			this.title = 'error';
			this.$toast.fail('参数错误');
		}
	},
	mounted() {
		this.$wx.ready(() => {
      this.$wx.updateAppMessageShareData({
        title: '福建省民族管弦乐学会',
        desc: '福建省民族管弦乐学会',
        link: location.href,
        imgUrl: 'http://guan.xuanyue.zaihukeji.cn/uploads/wx_share.png'
      })
      this.$wx.updateTimelineShareData({
        title: '福建省民族管弦乐学会',
        link: location.href,
        imgUrl: 'http://guan.xuanyue.zaihukeji.cn/uploads/wx_share.png'
      })
    });
	},
	methods: {
		upCallback(page, mescroll) {
			if (this.title == 'error') {
				this.$toast.fail('错误');
				mescroll.endSuccess(10, false);
				return;
			}
			// this.$get('')

			mescroll.endSuccess(10, false);
		}
	}
};
</script>

<style scoped lang="stylus">
.mescroll
	position fixed
	top 96px
	bottom 0
	height auto
.list
	padding 24px 30px
	.videoItem
		margin-bottom 28px
</style>
